<mat-drawer-container class="container" autosize (click)="onClick()">
  <mat-drawer
    [class.mini]="menuCollapsed"
    #drawer
    [opened]="isDrawerOpened"
    [mode]="drawerModeType"
    (openedStart)="(true)"
    (closedStart)="(false)"
    class="sidenav"
  >
    <div class="logo-wrapper d-flex justify-content-center align-items-center">
      <img
        src="assets/icons/logo.svg"
        *ngIf="!menuCollapsed"
        class="logo-lg"
        alt="My site services logo"
      />
      <img
        src="assets/icons/logo-sm.svg"
        *ngIf="menuCollapsed"
        class="logo-sm"
        alt="My site services logo"
      />
    </div>
    <app-sidenav></app-sidenav>
  </mat-drawer>

  <mat-drawer-content #mainContent class="main-content" style="overflow: auto">
    <!-- top toolbar -->
    <header class="header-toolbar-div">
      <mat-toolbar class="header-toolbar justify-content-between">
        @if (breakpoints == 'sm' || breakpoints == 'xs') {
        <div>
          <button class="unstyled-btn" (click)="toggleDrawer()">
            <img
            src="assets/icons/menu-burger.svg"
            class="hamburger"
            alt="menu icon"
          />
          </button>
         
        </div>
        }@else {
        <div class="ms-2">
          <!-- <span class="fs-18 font-weight-600">
              accountName </span> -->
          <!-- <span class="fs-18 font-weight-600 mx-1">|</span> -->
          <!-- <span class="fs-18 font-weight-600">
              accountNumber </span> -->
        </div>
        }
        <div class="d-flex justify-content-end align-items-center">
          @if (RBACTestEnabled) {
            <div>
              <mat-form-field appearance="outline" class="role-select">
                <mat-label>Select Role</mat-label>
                <mat-select #roleSelect [formControl]="roleFormControl" multiple>
                  @for (role of rolesList; track role) {
                    <mat-option [value]="role">{{role}}</mat-option>
                  }
                  <button mat-flat-button class="w-100" (click)="onApplyClick()">Apply</button>
                </mat-select>
              </mat-form-field>
            </div>
            }

            <app-user-menu></app-user-menu>
        </div>
       
      </mat-toolbar>
      @if (breakpoints != 'sm' && breakpoints != 'xs') {
      <div
        class="left-side-nav side-nav"
        [class]="{ 'mini-side-nav': menuCollapsed }"
        (click)="toggleSidenav(!menuCollapsed)"
      >
        <div class="vertical-line"></div>
        <img
          [class]="{ 'rotate-180': menuCollapsed }"
          src=" assets/icons/open-collapse.svg"
          alt="left side menu toggle"
        />
        <div class="vertical-line"></div>
      </div>
      }
       <!-- Environment Banner -->
    <app-environment-indicator></app-environment-indicator>
    </header>
    
   
    
    <div class="m-3">
      <router-outlet></router-outlet>
    </div>

    <!-- Download Status Component -->
    <app-download-status></app-download-status>

    <!-- footer -->

    <mat-toolbar
      color="primary"
      class="footer"
      [class.mini]="menuCollapsed && breakpoints != 'xs' && breakpoints != 'sm'"
    >
      <div class="fs-12 footer-div">
        <span class="font-weight-400"> ©</span>
        <span class="font-weight-400 mx-1">|</span>
        <span class="font-weight-700 footer-text">USS</span>
        <span class="font-weight-400 mx-1">|</span>
        <span class="font-weight-400">All rights reserved.</span>
      </div>
    </mat-toolbar>
  </mat-drawer-content>
</mat-drawer-container>
